<script setup>
    import Simple from '@/components/utils/FeedbackNotificationSimple.vue'
    import Full from '@/components/utils/FeedbackNotificationFull.vue'
</script>

<template>
    <AlertNotification position="top right">
        <template #body="props">
            <Full :item="props.item" />
        </template>
    </AlertNotification>
    
    <AlertNotification
        group="simple"
        position="top center"
    >
        <template #body="props">
            <Simple :item="props.item" />
        </template>
    </AlertNotification>
</template>
